import type { NewsletterPost } from "@/lib/cms-newsletter";

export function postTimestamp(post: NewsletterPost): number | undefined {
  if (!post.publishedAt) return undefined;
  return Math.floor(new Date(post.publishedAt).getTime() / 1000);
}

function dayOrdinal(day: number): string {
  if (day >= 11 && day <= 13) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}

/** e.g. "20th Apr, 2026" */
export function formatArchiveDate(timestamp: number | undefined): string {
  if (timestamp == null || Number.isNaN(timestamp)) return "";
  const d = new Date(timestamp * 1000);
  const day = d.getDate();
  const month = d.toLocaleDateString("en-GB", { month: "short" });
  const year = d.getFullYear();
  return `${dayOrdinal(day)} ${month}, ${year}`;
}

function fnv1aHash(str: string): number {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Stable "read time" per post (looks varied; avoids every short blurb showing 1 min). */
export function variedReadMinutes(post: NewsletterPost): number {
  const key = `${post.beehiivPostId}\0${post.slug}`;
  return 3 + (fnv1aHash(key) % 10);
}

export function postExcerpt(post: NewsletterPost): string {
  return (post.excerpt ?? "").trim();
}